import { AbstractControl, ValidatorFn } from '@angular/forms';
import DateHandler from '../models/dateHandler';

export default function isDateValidator(baseCentury: number): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    const date = new DateHandler(control.value, baseCentury);
    return control.value === null || control.value.length === 0 || date.isValid ? null : { isDate: true };
  };
}



// WEBPACK FOOTER //
// ./src/validators/isDateValidator.ts